import { createGlobalStyle } from 'styled-components';
import reboot from 'styled-reboot';

const rebootCss = reboot();

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;700;900&display=swap');
  ${rebootCss}

  :root {
    --background: #f5f5f5;
  }

  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    width: 100%;
    position: relative;
    left: 0;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'Raleway', sans-serif;
    font-weight: 400;
    font-size: 16px;
  }

  .clearme {
    position: relative;
    width: 100%auto;
    height: 10px;
  }

  .content-wrap {
    position: relative;
    margin: 10px auto;
    width: 100%;
    max-width: 1024px;
    padding: 0;
  }

  .col-wrap {
    position: relative;
    margin: 10px auto;
    width: 100%;
    max-width: 2014px;
    padding: 0;
  }


  .headerImg {
    position: relative;
    width: 100%;
    height: auto;
    margin-top: 2px;
  }

  .list-item-wrap {
    display: flex;
    width: 100%;
    height: 40px;
    margin-bottom: 4px;
  }

  h3 {
    margin-left: 140px;
    margin-top: 50px;
  }

  .name-wrap {
    display: flex;
    width: 140px;
    height: 40px;
    justify-content: end;
    align-items: center;

    p {
      padding: 0;
      font-size: 14px;
      line-height: 14px;
      margin: 0;
      margin-top: 2px;
      margin-right: 6px;
      text-align: right;
      width: 100%;
    }
  }

  .flag-wrap {
    display: flex;
    width: 60px;
    height: 40px;    
    justify-content: center;
    align-items: center;

    img {
      height: 30px;
      width: auto;
    }
  }

  .bar-wrap {
    position: relative;
    display: block;
    width: calc(100% - 205px);
    height: 40px;
  }

  .triangle {
    width: 0; 
    height: 0; 
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
  }

  .year {
    position: absolute;
    top: 11px;
    font-size: 14px;
    line-height: 14px;
    font-weight: 700;
  }

  .source {
    height: 90px;
    margin-top: 20px;
    font-size: 12px;
    line-height: 17px;
  }

    /* Menu Items */
    .menu {
    display: block;
    //margin-top: 20px;
    margin-bottom: 10px;
  }

  .fragment {
    margin-bottom: 20px;
  }

  .menu-item {
    display: inline-block;
    border: 1px solid black;
    border-radius: 16px;
    padding: 4px 14px;
    margin-right: 10px;
    margin-bottom: 15px;
    font-size: 14px;
    cursor: pointer;

    @media(max-width: 625px) {
      margin-right: 8px;
      margin-bottom: 12px;
      font-size: 12px;
      padding: 5px 10px;
    }
  }

  .menu-item.active {
    border: 1px solid black;
    background-color: black;
    color: white;
    cursor: auto;
  }

  .menu-item:hover {
    background-color: var(--background);
  }

  .menu-item.active:hover {
    background-color: black;
  }

  // top key
  .key-list {
    margin: 10px 10px 20px 10px;
  }
  .top-key {
    display: flex;
  }

  .ind1 {
    position: relative;
    width: 30px;
    height: 20px;
    background-color: #186c3b;
    margin-right: 8px;
    margin-bottom: 3px
  }

  .ind2 {
    position: relative;
    width: 30px;
    height: 20px;
    background-color: #26944c;
    margin-right: 8px;
    margin-bottom: 3px
  }

  .ind3 {
    position: relative;
    width: 30px;
    height: 20px;
    background-color: #70be66;
    margin-right: 8px;
    margin-bottom: 3px
  }

  .ind4 {
    position: relative;
    width: 30px;
    height: 20px;
    background-color: #f79d38;
    margin-right: 8px;
    margin-bottom: 3px
  }

  .ind5 {
    position: relative;
    width: 30px;
    height: 20px;
    background-color: #f17040;
    margin-right: 8px;
    margin-bottom: 3px
  }

`;

/* 
    Achieved: '#186c3b',
    'In Law': '#26944c',
    'Proposed Legislation': '#70be66',
    'In Policy Document': '#f79d38',
    'Still Talking': '#f17040',
  };
*/
